export const getNestedState = (state, keyPath) => {
    return keyPath.split('.').reduce((acc, key) => (acc && acc[key] !== undefined) ? acc[key] : null, state);
  };
